@use '../../../scss/utility';
@use './popover-vars';
@use '../../list-group/list-group-common';

:host {
  @include popover-vars.wb-popover-vars;

  display: inline-flex;
  position: relative;
}

.overlay {
  display: block;
  background-color: var(--popover-background-color);
  color: var(--popover-text-color);
  position: var(--popover-position);
  border: var(--popover-border-weight) solid var(--popover-border-color);
  border-radius: var(--popover-border-radius);
  overflow-x: hidden;
  overflow-y: auto;
  max-height: var(--max-height);
  max-width: var(--max-width);
  min-width: utility.wb-pixel-to-rem(190px);
  width: var(--popover-width);
  box-shadow: var(--wb-shadow-m);
  padding: var(--popover-padding);

  z-index: var(--z-index);
  box-sizing: content-box;

  @include utility.breakpoint-to(mq2) {
    width: 90vw; // using vw here is OK because we're on mobile devices where there is no scrollbar
  }

  @include utility.breakpoint-to(mq3) {
    @media (orientation: landscape) {
      max-height: var(--mobile-landscape-max-height); // fixing the height of the popover for landscape phones
    }
  }
}

:host(:not([open])) {
  overflow: hidden;

  .overlay {
    opacity: 0;
    pointer-events: none;
  }
}

:host([padded]) {
  @include popover-vars.wb-popover-padded-vars;
}

::slotted(.wb-list-group) {
  @include list-group-common.wb-list-group-hide-border;
}
